(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('InsertSOCEventsPlanController', InsertSOCEventsPlanController);

    InsertSOCEventsPlanController.$inject = ['parameters', 'FileUploadService', 'SoopkitchenUtils',  '$scope', '$uibModalInstance', '$window'];

    function InsertSOCEventsPlanController (parameters, FileUploadService, SoopkitchenUtils, $scope, $uibModalInstance, $window) {

        var vm = this;

        /**** Properties ****/
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.isUploading = false;
        vm.ascending = true;
        vm.predicate = null;
        vm.uploadStrategy = 'conflicts';

        /**** Methods ****/
        vm.uploadFiles = uploadFiles;
        vm.upload = upload;
        vm.downloadPointings = downloadPointings;
        vm.close = close;

        function uploadFiles(files) {
            vm.files = files;
        }

        function successUpload(response) {
            var listPointings = [];
            response.data.eventsTimeline.happenings.forEach(function(h) {
                if (h.name.startsWith("POINT")) listPointings.push(h)});
            var text = '<div class="table-wrapper-scroll-x table-wrapper-scroll-y">';
            text += '<table class="jh-table table table-striped"><tbody>';
            listPointings.forEach(function(pointing) {

                text += '<tr>';
                text += '<td nowrap style="text-align:left;vertical-align:top">' + pointing.name + " " + pointing.startDate + "->" + pointing.endDate + "</br>"; + '</td>';
                text += '</tr>';
            })
            text += '</table></div>';
            SoopkitchenUtils.prettyConfirmHtml("Pointings in Plan (total: " +listPointings.length+ ")", text,  reloadCallback);

        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }

        function reloadCallback() {
            location.reload();
        }


        function upload () {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                FileUploadService.uploadFiles(vm.files, 'api/'+ parameters.planType +'/event/add-soc-events-file?strategy=' + vm.uploadStrategy, parameters.label, successUpload,
                    failureUpload, FileUploadService.progressCallback,
                    parameters.label);
            }
        }
        function downloadPointings () {
            var url = 'api/' + parameters.planType + '/export-pointings/' + window.encodeURIComponent(parameters.label) + '/' + parameters.internalVersion;
            $window.open(url);
            $uibModalInstance.dismiss('cancel');
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
